module.exports = __webpack_public_path__ + "files/cb5c9312e078311e4ae7a2a695e0d5ab.svg";